import { render, staticRenderFns } from "./TwoColumnCustomBlock.vue?vue&type=template&id=2ac80a16"
import script from "./TwoColumnCustomBlock.vue?vue&type=script&lang=js"
export * from "./TwoColumnCustomBlock.vue?vue&type=script&lang=js"
import style0 from "./TwoColumnCustomBlock.vue?vue&type=style&index=0&id=2ac80a16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports